var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36323 24.4066H29C29.5523 24.4066 30 23.9589 30 23.4066V1C30 0.447715 29.5523 0 29 0H4.29248C3.15517 0.00328479 2.06548 0.410588 1.26128 1.133C0.457073 1.85542 0.00365668 2.83428 0 3.85593V26.3293C0 26.3389 0 26.3484 0 26.3581C0 28.6081 1.96571 30 4.29248 30H29.2372C29.6585 30 30 29.6585 30 29.2372C30 28.8159 29.6585 28.4744 29.2372 28.4744H4.29248C3 28.4744 1.5 27.9661 1.5 26.3579C1.5 24.7497 3 24.4066 4.36323 24.4066ZM23.4121 1.54659V14.056L20.217 11.3554L17.0938 14.0402V1.54659H23.4121ZM15.5849 1.52542V14.7626C15.5849 15.3149 16.0326 15.7626 16.5849 15.7626H17.0938L20.2252 13.0513L23.4121 15.7626H23.9057C24.4579 15.7626 24.9057 15.3149 24.9057 14.7626V1.52542H28.5V22.8814H6L5.99434 1.52542H15.5849ZM4.29248 1.52542H4.5283L4.53368 22.8814H4.36295C3.62674 22.8815 2.5 22.8814 2 23.3898V3.85593C2 3.05085 2.475 2.4122 2.85525 2.06764C3.2355 1.72308 3.75238 1.52808 4.29248 1.52542Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.6dea57d0d93654f3880a966b6b58b23c.svg";
export { ForwardRef as ReactComponent };